export const ADOBE_PLUGIN_MARKETPLACE_URL =
  'https://exchange.adobe.com/apps/cc/108662/storyblocks';

export const ADOBE_PLUGIN_LANDING_PAGE_RELATIVE_PATH =
  '/adobe-creative-cloud-plugin';
